module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/common-energy-corning-glass-announce-partnership/"},"frontmatter":{"title":"Common Energy & Corning Glass Announce Partnership"}}}]}},"pathContext":{"tag":"New York"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-new-york.json
// module id = 436
// module chunks = 273550284943575